import { apiFetch } from "../../api/apiFetch";
﻿
export async function getDocumentFolders(parentID, appid) {
    var url;
    if (parentID) {
        url = '/api/document/getfolders?parentid=' + parentID + '&appid=' + appid;
    }
    else {
        url = '/api/document/getfolders?appid=' + appid;
    }
    const response = await apiFetch(url);
    if (response.status !== 200) 
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function getFolder(id){
    const response = await apiFetch('/api/document/getfolder?id=' + id);
    if (response.status === 200) {
        const data = await response.json();
        if (data)
            return data;
    }
        return null;
}
export async function getDocument(documentid, userid) {
    return apiFetch(`/api/document/getdocument?documentid=${documentid}&userid=${userid}`);
    //if (response.status === 200) {
    //    const data = await response.json();
    //    if (data)
    //        return data;
    //}
    //    return null;
}

export async function downloadDocument(id) {
    const response = await apiFetch('/api/document/downloaddocument?id=' + id);
    if (response.status === 200) {
        const data = await response.blob();
        console.log(data);
        if (data) {
            const fileURL = window.URL.createObjectURL(data);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.target = "_blank";
            alink.click();
        }

    }
    return null;
}
//export async function getDocumentInfo(id) {
//    const response = await apiFetch('/api/document/getdocumentInfo?id=' + id);
//    if (response.status === 200) {
//        const data = await response.json();
//        if (data)
//            return data;
//    }
//    return null;
//}
export async function getDocumentInfo(documentid, userid) {
    return apiFetch(`/api/document/getdocumentInfo?documentid=${documentid}&userid=${userid}`);
}
export async function newDocument(file, parentID, appid){
    const fileName = file.name;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('parentid', parentID);
    formData.append('appid', appid);

    const doc = await apiFetch('/api/document/uploadfile', {
        method: 'POST',
        body: formData
    }).then(
        response => response.json()
    ).then(
        response => {
            var newID = response;
            var doc = { documentID: newID, documentName: fileName, createDate: new Date().toISOString() };
            return doc;
        }
    ).catch((error) => {
        console.log(error);
        return null;
    });
    return doc;
}
//export async function newOwnerDocument(file, ownerid, parentID, appid) {
//    const fileName = file.name;
//    const formData = new FormData();
//    formData.append('file', file);
//    formData.append('parentid', parentID);
//    formData.append('userid', ownerid);
//    formData.append('appid', appid);

//    const doc = await apiFetch('/api/document/uploadownerfile', {
//        method: 'POST',
//        body: formData
//    }).then(
//        response => response.json()
//    ).then(
//        response => {
//            var newID = response;
//            var doc = { documentID: newID, documentName: fileName, createDate: new Date().toISOString() };
//            return doc;
//        }
//    ).catch((error) => {
//        console.log(error);
//        return null;
//    });
//    return doc;
//}
// Helper: convert a File/Blob to base64 (no data: prefix)
async function fileToBase64(file) {
    const arrayBuffer = await file.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);

    // Convert bytes -> binary string in chunks to avoid call stack limits
    let binary = "";
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
}

export async function newOwnerDocument(file, ownerid, parentID, appid) {
    try {
        if (!file) return null;

        const fileName = file.name || "New Document";
        const mime = file.type || "application/octet-stream";
        const ext = fileName.includes(".") ? fileName.slice(fileName.lastIndexOf(".")) : "";

        // BFF behavior: if parentid is empty, it uses userid
        const effectiveParentId = parentID || ownerid;

        // 1) Create the document record
        const createPayload = {
            UserID: ownerid,
            Name: fileName,
            ParentID: effectiveParentId,
            AppID: appid,
        };

        const docid = await apiFetch("/api/document/createdocument", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(createPayload),
        })
            .then((r) => {
                if (!r.ok) throw new Error(`createdocument failed (${r.status})`);
                return r.json(); // API returns a JSON string (docid)
            });

        if (!docid) return null;

        // 2) Upload the file content (as base64, matching how .NET byte[] is typically deserialized)
        const base64 = await fileToBase64(file);

        const addDocPayload = {
            DocID: docid,
            BinaryContent: base64,   // IMPORTANT: base64 string for .NET byte[]
            MimeType: mime,
            Extension: ext,
        };

        // The BFF awaited this but didn't enforce success; it still returns docid.
        await apiFetch("/api/document/addedoc", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(addDocPayload),
        }).then((r) => {
            // Mirror BFF "best effort" behavior: don't fail the whole function if this fails,
            // but do log it.
            if (!r.ok) {
                console.warn(`addedoc failed (${r.status})`);
            }
            // If you want to parse it:
            // return r.ok ? r.json() : null;
        });

        // Return the same result shape as your existing function
        return {
            documentID: docid,
            documentName: fileName,
            createDate: new Date().toISOString(),
        };
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function deleteDocument(id) {
    const req = { DocID: id };
    const response = await apiFetch("/api/document/deletedocument", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}

export async function renameDocument(id, name) {
    const req = { DocID: id, Name: name };
    const response = await apiFetch("/api/document/editdocument", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function moveDocument(id, parentid) {
    const req = { DocID: id, ParentID: parentid };
    const response = await apiFetch("/api/document/movedocument", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function newFolder(name, parentID, appid) {
    const req = { Name: name, ParentID: parentID, AppID: appid };
    const response = await apiFetch("/api/document/createfolder", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const data = await response.json();
        if (data) {
            const folder = { id: data, name: name, documents: [] };
            return folder;
        }
    }
    return false;
}
export async function newOwnerFolder(name, userid, parentID, appid) {
    const req = { Name: name, ParentID: parentID, AppID: appid, UserID: userid };
    const response = await apiFetch("/api/document/createfolder", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const data = await response.json();
        if (data) {
            const folder = { id: data, name: name, documents: [] };
            return folder;
        }
    }
    return false;
}

export async function deleteFolder(id) {
    const req = { FolderID: id };
    const response = await apiFetch("/api/document/deletefolder", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}

export async function renameFolder(id, name) {
    const req = { FolderID: id, Name: name };
    const response = await apiFetch("/api/document/editfolder", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}

export async function shareDocument(id, ownerid, userid, isFolder, appid, canedit, hasexpiration, expiration) {
    const req = {
        DocID: id,
        OwnerID: ownerid,
        UserId: userid,
        IsFolder: isFolder,
        AppID: appid,
        CanEdit: canedit,
        HasExpiration: hasexpiration,
        Expiration: expiration
    };
    const response = await apiFetch("/api/document/sharecontent", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}
export async function unShareDocument(id, ownerid, userid, appid) {
    const req = {
        DocID: id,
        OwnerID: ownerid,
        UserId: userid,
        AppID: appid
    };
    const response = await apiFetch("/api/document/unsharecontent", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}
export async function hideSharedDocument(id, ownerid, userid, appid) {
    const req = {
        DocID: id,
        OwnerID: ownerid,
        UserId: userid,
        AppID: appid
    };
    const response = await apiFetch("/api/document/hidesharedcontent", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}
export async function unhideSharedDocument(id, ownerid, userid, appid) {
    const req = {
        DocID: id,
        OwnerID: ownerid,
        UserId: userid,
        AppID: appid
    };
    const response = await apiFetch("/api/document/unhidesharedcontent", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}

export async function addEvent(docID, parentid, eventType, fromstatus, tostatus) {
    const response = await fetch("document/addevent?docid=" + docID + "&parentid=" + parentid + "&eventType=" + eventType + "&fromstatus=" + fromstatus + "&tostatus=" + tostatus);
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function addNote(docid, note) {
    const response = await fetch("document/addnote?docid=" + docid + "&note=" + note);
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}

export async function openDocumentInNewTab(id) {
    const response = await fetch('/document/downloaddocument?id=' + id);

    if (response.status === 200) {
        const data = await response.blob();

        if (data) {
            const fileURL = window.URL.createObjectURL(data);
            window.open(fileURL, "_blank");

            // Optional cleanup to avoid memory leaks
            setTimeout(() => {
                URL.revokeObjectURL(fileURL);
            }, 30000);
        }
    }

    return null;
}

export async function setDocumentStatus(id, status) {
    const response = await fetch("document/setdocumentstatus?documentid=" + id + "&documentstatus=" + status);
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}